import React, {useEffect, useState} from "react";
import useTable from "../../components/table/useTable";
import TableFooter from "../../components/table/TableFooter";
import {FiX,FiEdit2} from 'react-icons/fi';
import {get,post,put,del} from '../../store/config/register';
import { empresa_Id} from "../../store/config/dadosuser";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { toast } from "react-toastify";


const initialState ={
    veiculo: {
      id: 0,
      pessoa_Id: 0,
      empresa_Id: empresa_Id,
      marca:'',
      modelo: '',
      cor: '',
      placa: ''

    }
  }

  
export default function Veiculo(props){

    const [veiculo,setVeiculo]=useState(initialState.veiculo);
    const [veiculos,setVeiculos]=useState([]);
    const [page, setPage] = useState(1);
    const { slice, range } = useTable(veiculos, page, 10);
    const {idVisita} =useParams();

    const search = props.location.search;
    const params = new URLSearchParams(search);
    let id=0;

    if(params !== undefined){
      if(params.get("Visitante")!==null){
        id =params.get("Visitante");
      }
    }

    if(id == 0 && idVisita !== undefined){
        id =idVisita;
    }

    function  updateField(event){
        const vei ={...veiculo}
          
        vei[event.target.name] =event.target.value.toUpperCase()
        setVeiculo(vei);
  }

  function clear(){  
    setVeiculo(initialState.veiculo);
  }

  useEffect(()=>{
    buscaVeiculos(id);
  },[veiculos])

  

  async   function buscaVeiculos(id){
    const veics = await  get(`/Veiculo/v1/Pessoa/${id}`);
    setVeiculos(veics);
  }

  function Validar(){
    if(id === undefined){
        toast.warning("salve o hospede antes de adicionar o veículo")
        return false;
    }

    if(veiculo.marca === ''){
        toast.warning("preencha o campo de marca para gravar o veículo")
        return false;
    }

    if(veiculo.modelo === ''){
        toast.warning("preencha o campo de modelo para gravar o veículo")
        return false;
    }

    if(veiculo.cor === ''){
        toast.warning("preencha o campo de cor para gravar o veículo")
        return false;
    }

    if(veiculo.placa === ''){
        toast.warning("preencha o campo de placa para gravar o veículo")
        return false;
    }

    return true;
  }

  async function salvarVeiculo(){
    if(Validar()){
        veiculo.pessoa_Id = parseInt(id);
    veiculo.empresa_Id = empresa_Id;
    if (veiculo.id == 0){
        await post('/Veiculo/v1',veiculo);
    }else {
        await put('/Veiculo/v1/'+veiculo.id,veiculo);
    }
    

    await buscaVeiculos(id);
    toast.success('Veículo adicionado com sucesso.')
    clear();
    }
    
  }

  function Editar(item){
    setVeiculo(item);
  }

async function Deletar(idVeiculo){
   await del('/Veiculo/v1/'+idVeiculo);
   toast.success('Veículo removido com sucesso.')
    buscaVeiculos(id);
}

    function renderForm(){

        return(
            <div className="form">
                <div className="nome-visitante">
                    <div className="form-group">
                    <label>Marca:</label>
                    <input type="text" name="marca" 
                    placeholder="Marca" 
                        className="form-control" value={veiculo.marca} 
                        onChange={e => updateField(e)} />
                    </div>
                </div> 
                <div className="nome-visitante">
                    <div className="form-group">
                    <label>Modelo:</label>
                    <input type="text" name="modelo" 
                    placeholder="Modelo" 
                        className="form-control" value={veiculo.modelo} 
                        onChange={e => updateField(e)} />
                    </div>
                </div>
                <div className="nome-visitante">
                    <div className="form-group">
                    <label>Cor:</label>
                    <input type="text" name="cor" 
                    placeholder="Cor" 
                        className="form-control" value={veiculo.cor} 
                        onChange={e => updateField(e)} />
                    </div>
                </div> 
                <div className="nome-visitante">
                    <div className="form-group">
                    <label>Placa:</label>
                    <input type="text" name="placa" 
                    placeholder="Placa" 
                        className="form-control" value={veiculo.placa} 
                        onChange={e => updateField(e)} />
                    </div>
                </div>

                <div id="botao">
                  <button  className="btn btn-primary ml-2" onClick={ async e =>  await salvarVeiculo()}>
                    Salvar
                  </button>
                  <button className="btn btn-secondary ml-2" onClick={e => clear()}>
                    Cancelar
                  </button>
            </div>
            <hr />
            {renderTable()}  
        </div>
        );
    }

    function renderTable(){
        return (
            <div className='tabela'>
                <table>
                    <thead>
                        <tr>
                        <th scope="col">Marca</th>
                        <th scope="col">Modelo</th>
                        <th scope="col">Cor</th>
                        <th scope="col">Placa</th>
                        </tr>
                    </thead>
                    <tbody>
                    {slice === undefined ? null :slice.map((item, index)=>{
                        return (
                    <tr key={index}>
                      <td data-label="Marca">{item.marca}</td>
                      <td data-label="Modelo">{item.modelo}</td>
                      <td data-label="Cor">{item.cor}</td>
                      <td data-label="Placa">{item.placa}</td>
                    <td  data-label="">
                      <button className="action" style={{backgroundColor: '#F99E08' ,marginRight: "20px" }} data-toggle="tooltip" data-placement="bottom" title="Editar" onClick={ ( e) => Editar(item)} >
                        <FiEdit2 color="#FFF" size={17} />
                        </button>
                        <button className="action" style={{backgroundColor: '#ff0000', marginTop: "10px" }} data-toggle="tooltip" data-placement="bottom" title="Excluir Visitante"  onClick={async(e) => await Deletar(item.id)} >
                        <FiX color="#FFF" size={17} />
                        </button>
                        </td>
                    </tr>
                        );

                    })}
                    </tbody>
                </table>
                <TableFooter range={range} slice={slice} setPage={setPage} page={page} />
            </div>
        );
    }
    return (
        <div>
            {renderForm()}
        </div>
    );
}